// Token-based substring match for type-ahead filters.
//
// Splits the query on any run of non-alphanumeric characters
// ("il_tue_pm_nor" -> ["il", "tue", "pm", "nor"]) and matches when EVERY token
// appears somewhere in the haystack. This makes underscore-segmented values
// (route names like "il_chi_tue_pm_northeast") searchable even when the user
// skips a segment — a strict contiguous `includes` would miss those. An empty
// query matches everything.
export default function searchMatch(haystack, query) {
  const tokens = (query || '')
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(Boolean);
  if (tokens.length === 0) return true;
  const hay = (haystack || '').toLowerCase();
  return tokens.every((token) => hay.includes(token));
}
